import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {KennethMustDie} from "../KennethMustDie";
import {X_WAYS_ANIMATIONS} from "../server/IKMDData";

export class KMDXWaysReveal extends PIXI.Container implements StageLayer {

    private _items: PIXI.spine.Spine[] = [];

    constructor() {
        super();
        this.name = "KMDXWaysReveal";

        this.init();
    }

    public playRevealAnimation(x: number, y: number, reelId: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            item: PIXI.spine.Spine = this._items[reelId];

        tl.add([
            () => {
                item.position.set(x, y);
                item.visible = true;
            },
            KennethMustDie.createTimelineForAnimation(item, 0, X_WAYS_ANIMATIONS.REVEAL, false)
        ]);

        return tl;
    }

    public addNoWinTint(reelId: number): void {
        if (reelId > 0 && reelId < KennethMustDie.REELS_NUM - 1) {
            this._items[reelId].autoUpdate = true;
            this._items[reelId].tint = 0x777777;
        }
    }

    public removeNoWinTint(reelId: number): void {
        if (reelId > 0 && reelId < KennethMustDie.REELS_NUM - 1) {
            this._items[reelId].autoUpdate = true;
            this._items[reelId].tint = 0xffffff;
        }
    }

    public hideItem(reelId: number): void {
        if (reelId > 0 && reelId < KennethMustDie.REELS_NUM - 1) {
            this._items[reelId].visible = false;
            this._items[reelId].autoUpdate = true;
            this._items[reelId].tint = 0xffffff;
        }
    }

    public hideAll(): void {
        this._items.forEach((item: PIXI.spine.Spine, idx: number) => {
            if (item) {
                this.hideItem(idx);
            }
        });
    }

    private init(): void {
        this._items = [];

        // xWays only exists in middle 3 reels. keep the 0th index free.
        for (let reelId: number = 1; reelId < KennethMustDie.REELS_NUM - 1; reelId++) {
            const item: PIXI.spine.Spine = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("xWaysReveal"));

            item.visible = false;
            this._items[reelId] = item;
            this.addChild(item);
        }
    }
}